<template>
	<div class="grid grid-cols-2 min-h-screen">
		<div class="__setup-center px-12 md-down:px-4 pb-30">
			<div
				class="
					__setup-center__header
					pt-10
					pb-4
					flex
					justify-between
					gap-8
					items-center
					lg:flex-nowrap
					flex-wrap
				"
			>
				<div
					class="
						__record__title
						text-neutral-500
						font-semibold
						whitespace-nowrap
						flex flex-nowrap
						items-center
						text-4xl
						cursor-pointer
					"
					@click="$router.back()"
				>
					<svg
						class="mr-2"
						width="28"
						height="28"
						viewBox="0 0 28 28"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M17.5 7L10.5 14L17.5 21"
							stroke="#94A3B8"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					Thêm học sinh
				</div>
				<div
					class="search-input w-80 lg-down:ml-auto"
					style="min-width: 120px"
				>
					<div class="input-group input--xl">
						<input
							type="text"
							placeholder="Tìm theo học sinh"
							class="bg-white input-with-icon"
							v-model="searchQuery"
							@keyup="searching"
							@keypress.enter="search"
						/>
						<div class="input-icon absolute top-1/2">
							<DaIcon
								name="das--search"
								class="h-4 w-4 text-neutral-400"
							/>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div>
					<div
						class="font-semibold text-neutral-500"
						v-if="students.length"
					>
						Chọn học sinh để thêm vào lớp bán trú*
					</div>
					<div
						class="shadow-sm sm:rounded-2xl mt-12"
						v-if="students.length"
					>
						<div class="__record__table overflow-x-auto scroll-bar">
							<div
								class="
									overflow-hidden
									sm:rounded-t-2xl
									w-fit
									min-w-full
								"
							>
								<table
									class="min-w-full divide-y text-neutral-200"
								>
									<thead class="bg-neutral-100 h-16">
										<tr>
											<th
												scope="col"
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													w-16
													whitespace-nowrap
												"
											>
												STT
											</th>
											<th
												scope="col"
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													whitespace-nowrap
												"
											>
												Tên học sinh
											</th>
											<th class="w-8"></th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(
												person, index
											) in this.students.filter(
												(s) =>
													!this.checkBoxSelected.includes(
														s.id
													)
											)"
											:key="person.id"
											:class="
												index % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											"
											class="
												text-neutral-700
												hover:bg-orange-50
											"
										>
											<td>
												<div
													class="
														px-6
														py-4
														text-neutral-700
													"
												>
													{{ index + 1 }}
												</div>
											</td>
											<td
												class="
													px-6
													py-4
													whitespace-nowrap
													text-neutral-700
												"
												style="width: 250px"
											>
												<div class="flex items-center">
													<div>
														<img
															class="
																shadow-sm
																inline-block
																h-6
																w-6
																rounded-full
															"
															:src="
																person
																	?.profile_photo
																	?.w200
															"
															alt=""
															v-if="
																person
																	?.profile_photo
																	?.w200
															"
														/>
														<span
															v-else
															class="
																inline-flex
																items-center
																justify-center
																h-6
																w-6
																rounded-full
															"
															:style="{
																background:
																	person
																		?.profile_photo
																		?.default
																		?.color,
															}"
														>
															<span
																class="
																	font-medium
																	leading-none
																	text-white
																	text-xs
																"
																>{{
																	person
																		?.profile_photo
																		?.default
																		?.initial
																}}</span
															>
														</span>
													</div>
													<div
														class="
															ml-4
															text-orange-600
															font-semibold
															truncate
														"
													>
														{{ person.name }}
													</div>
												</div>
											</td>
											<td>
												<Checkbox
													:value="
														checkBoxSelected.find(
															(id) =>
																id === person.id
														)
													"
													@click.stop="
														checkChanged(person.id)
													"
												/>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div
						v-else
						class="
							w-full
							h-full
							mt-20
							flex
							items-center
							justify-center
							flex-col
						"
					>
						<img
							src="@/assets/images/illustrations/not_found.png"
							alt=""
							height="250"
							width="250"
						/>
						<div
							class="text-neutral-500 text-lg text-center"
							style="max-width: 700px"
						>
							Rất tiếc, chúng tôi không thể tìm thấy kết quả cho
							tìm kiếm của bạn.
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bg-white p-12">
			<div class="font-semibold text-neutral-600">
				Danh sách học sinh đã chọn
			</div>
			<div class="text-neutral-400 mt-1">
				Danh sách học sinh đã chọn sẽ được thêm vào lớp bán trú
			</div>
			<div class="flex items-center gap-5 mt-6">
				<div
					class="
						w-1/2
						p-4
						shadow-sm
						rounded-xl
						bg-white
						flex
						items-center
						justify-between
					"
				>
					<div
						class="text-neutral-500 text-sm flex items-center gap-4"
					>
						<svg
							width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M5.99666 20C6.21401 19.9999 6.4291 19.9559 6.62903 19.8706C6.82897 19.7854 7.00964 19.6607 7.16022 19.5039C7.3108 19.3472 7.42819 19.1617 7.50536 18.9585C7.58253 18.7553 7.61788 18.5386 7.60931 18.3214L7.33907 9.88249L8.5167 9.17284C8.8171 8.99077 9.06357 8.73196 9.23077 8.42305C9.39797 8.11413 9.47987 7.76625 9.46803 7.41518L9.23294 0.617447C9.22724 0.453467 9.15807 0.298112 9.04002 0.184158C8.92197 0.0702041 8.76427 0.00656322 8.60019 0.00666215C8.43688 0.00828381 8.28053 0.0729825 8.16383 0.187227C8.04713 0.301471 7.97912 0.456412 7.97402 0.619645L7.80924 4.85559C7.80781 4.98185 7.76112 5.1034 7.67766 5.19815C7.5942 5.2929 7.47951 5.35455 7.35445 5.37191C7.28497 5.37951 7.21467 5.37268 7.14795 5.35184C7.08124 5.33101 7.01954 5.29662 6.96674 5.25082C6.91393 5.20503 6.87116 5.14883 6.84109 5.08573C6.81102 5.02264 6.79431 4.95401 6.792 4.88416L6.62722 0.643812C6.62335 0.498377 6.57147 0.358308 6.47966 0.245442C6.38786 0.132576 6.26129 0.0532551 6.1197 0.0198446C6.03534 0.00562738 5.94919 0.00562738 5.86484 0.0198446C5.72324 0.0532551 5.59667 0.132576 5.50487 0.245442C5.41306 0.358308 5.36118 0.498377 5.35731 0.643812L5.19253 4.88416C5.19022 4.95401 5.17351 5.02264 5.14344 5.08573C5.11337 5.14883 5.0706 5.20503 5.01779 5.25082C4.96499 5.29662 4.9033 5.33101 4.83658 5.35184C4.76986 5.37268 4.69956 5.37951 4.63008 5.37191C4.50502 5.35455 4.39033 5.2929 4.30687 5.19815C4.22341 5.1034 4.17672 4.98185 4.17529 4.85559L4.00392 0.619645C3.99875 0.45336 3.92829 0.295802 3.80781 0.181078C3.68733 0.0663532 3.52652 0.00369344 3.36018 0.00666215C3.1961 0.00656322 3.0384 0.0702041 2.92034 0.184158C2.80229 0.298112 2.73312 0.453467 2.72742 0.617447L2.50112 7.41738C2.48929 7.76844 2.57118 8.11632 2.73838 8.42524C2.90558 8.73416 3.15206 8.99296 3.45245 9.17503L4.65205 9.89567L4.38181 18.3214C4.37323 18.5388 4.40865 18.7557 4.48596 18.959C4.56326 19.1623 4.68085 19.3479 4.83166 19.5047C4.98248 19.6615 5.16341 19.7862 5.36361 19.8713C5.5638 19.9564 5.77913 20.0002 5.99666 20Z"
								fill="#3B82F6"
							/>
							<path
								d="M17.8125 8.24569C18.1252 7.6708 18.287 7.026 18.2827 6.37159C18.2673 4.22065 17.8784 0.0220559 14.7872 8.5179e-05C11.6959 -0.0218855 11.307 4.21187 11.2916 6.37159C11.2866 7.0258 11.4477 7.6706 11.7596 8.24569C12.0901 8.85577 12.5779 9.3663 13.1723 9.72431L13.4623 9.90008L13.1943 18.3214C13.1863 18.5355 13.2216 18.7489 13.298 18.9489C13.3744 19.149 13.4904 19.3316 13.639 19.4858C13.7876 19.64 13.9658 19.7627 14.1629 19.8465C14.3599 19.9303 14.5719 19.9735 14.7861 19.9735C15.0002 19.9735 15.2122 19.9303 15.4093 19.8465C15.6063 19.7627 15.7845 19.64 15.9331 19.4858C16.0817 19.3316 16.1977 19.149 16.2741 18.9489C16.3505 18.7489 16.3858 18.5355 16.3778 18.3214L16.1032 9.89568L16.3932 9.71992C16.9894 9.36403 17.4795 8.855 17.8125 8.24569Z"
								fill="#3B82F6"
							/>
						</svg>
						<span class="font-semibold"
							>Lớp {{ classDetail.name }}</span
						>
					</div>
				</div>
				<div
					class="
						w-1/2
						flex
						items-center
						justify-between
						gap-2
						py-4
						px-6
					"
				>
					<div
						class="font-normal"
						style="color: #65758b; font-size: 14px"
					>
						Học sinh
					</div>
					<div class="text-4xl font-bold" style="color: #48566a">
						{{ studentsInClass.length }}
					</div>
				</div>
			</div>
			<div>
				<div class="flex flex-col">
					<div
						class="shadow-sm sm:rounded-2xl mt-6"
						v-if="allStudents.length"
					>
						<div class="__record__table overflow-x-auto scroll-bar">
							<div
								class="
									overflow-hidden
									sm:rounded-t-2xl
									w-fit
									min-w-full
								"
							>
								<table
									class="min-w-full divide-y text-neutral-200"
								>
									<thead class="bg-neutral-100 h-16">
										<tr>
											<th
												scope="col"
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													w-16
													whitespace-nowrap
												"
											>
												STT
											</th>
											<th
												scope="col"
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													whitespace-nowrap
												"
											>
												Tên học sinh
											</th>
											<th class="w-8"></th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(
												person, index
											) in studentsInClass"
											:key="person.id"
											:class="
												index % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											"
											class="
												text-neutral-700
												hover:bg-orange-50
											"
										>
											<td>
												<div
													class="
														px-6
														py-4
														text-neutral-700
													"
												>
													{{ index + 1 }}
												</div>
											</td>
											<td
												class="
													px-6
													py-4
													whitespace-nowrap
													text-neutral-700
												"
												style="width: 250px"
											>
												<div class="flex items-center">
													<div>
														<img
															class="
																shadow-sm
																inline-block
																h-6
																w-6
																rounded-full
															"
															:src="
																person
																	?.profile_photo
																	?.w200
															"
															alt=""
															v-if="
																person
																	?.profile_photo
																	?.w200
															"
														/>
														<span
															v-else
															class="
																inline-flex
																items-center
																justify-center
																h-6
																w-6
																rounded-full
															"
															:style="{
																background:
																	person
																		?.profile_photo
																		?.default
																		?.color,
															}"
														>
															<span
																class="
																	font-medium
																	leading-none
																	text-white
																	text-xs
																"
																>{{
																	person
																		?.profile_photo
																		?.default
																		?.initial
																}}</span
															>
														</span>
													</div>
													<div
														class="
															ml-4
															text-orange-600
															font-semibold
															whitespace-pre-wrap
															w-40
														"
													>
														{{ person.name }}
													</div>
												</div>
											</td>
											<td>
												<Checkbox
													:value="
														checkBoxSelected.find(
															(id) =>
																id === person.id
														)
													"
													@click.stop="
														checkChanged(person.id)
													"
												/>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-6 flex justify-end">
					<button
						type="button"
						class="button-p text-center w-32"
						@click="addStudents"
					>
						Xác nhận
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DaIcon from '@/components/elements/daIcon/DaIcon';
import { $api } from '@/services';
import Checkbox from '@/components/elements/checkbox/Checkbox';
import { toEnglish } from '@/helper/toEnglish';
export default {
	name: 'GroupClassAddStudents',

	components: { Checkbox, DaIcon },

	data() {
		return {
			searchQuery: '',
			students: [],
			allStudents: [],
			allStudentsAdded: [],
			params: {},
			checkBoxSelected: [],
			classDetail: {},
			typing: null,
			groupClass: {},
		};
	},

	created() {
		this.fetchStudents().then(() => this.fetchStudentInClass());
	},

	computed: {
		id() {
			return String(this.$route.params.id);
		},

		studentsInClass() {
			return this.allStudents.filter((s) =>
				this.checkBoxSelected.includes(s.id)
			);
		},

		isAdmin() {
			return this.$store.getters.isAdmin;
		},
	},

	methods: {
		async fetchStudents() {
			try {
				const {
					data: { data },
				} = await $api.boarding.getStudentInClassCanAdd();
				this.students = data.map((item) => {
					return {
						...item,
						nameSearch: toEnglish(item?.name),
					};
				});
				this.allStudents = [...data].map((item) => {
					return {
						...item,
						nameSearch: toEnglish(item?.name),
					};
				});
			} catch (err) {
				console.log(err);
			}
		},

		checkChanged(id) {
			const result = this.checkBoxSelected.find((item) => item === id);

			if (result) {
				this.checkBoxSelected = this.checkBoxSelected.filter((item) => {
					return item !== id;
				});
			} else {
				this.checkBoxSelected.push(id);
			}
		},

		async search() {
			this.students = this.allStudents.filter((s) => {
				return (
					this.formatTextSearch(s.nameSearch).includes(
						this.formatTextSearch(this.searchQuery)
					) ||
					this.formatTextSearch(s.name).includes(
						this.formatTextSearch(this.searchQuery)
					) ||
					this.formatTextSearch(s.unaccent_name).includes(
						this.formatTextSearch(this.searchQuery)
					)
				);
			});
		},

		formatTextSearch(text) {
			if (!text) {
				return '';
			}
			return text.toLowerCase();
		},

		searching() {
			clearInterval(this.typing);
			this.typing = setTimeout(() => {
				this.search();
			}, 1000);
		},

		async addStudents() {
			try {
				await $api.boarding.addStudents(this.id, {
					student_ids: this.studentsInClass.map((s) => s.id),
				});
				await this.$store.dispatch('setAlertMessage', {
					message: 'Thêm học sinh vào lớp bán trú thành công',
				});
				await this.$router.push(`/daycare-class/${this.id}`);
			} catch (err) {
				const error =
					err?.response?.data?.errors ||
					err?.message ||
					'Đã có lỗi xảy ra. Vui lòng thử lại';
				await this.$store.dispatch('setAlertMessage', {
					message: error,
					type: 'danger',
				});
			}
		},
		async fetchStudentInClass() {
			try {
				const {
					data: { class_data, data },
				} = await $api.boarding.getStudentInClass(this.id);
				this.classDetail = class_data;
				this.students = [...this.students, ...data];
				this.allStudents = [...this.allStudents, ...data];
				this.checkBoxSelected = [...data].map((s) => s.id);
			} catch (e) {
				console.log(e);
			}
		},
	},
};
</script>
